module.exports = __webpack_public_path__ + "static/media/encerrada-junte-troque.4c411bef.png";